import React from 'react';
import { Form, Formik } from 'formik';
import { Button, Grid, SideSheet } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { clientContactFormValidation } from '../../validation/clients/ClientContactFormValidation';
import { ClientContactForm } from './ClientContactForm';
import { EditContactFormStatusWrapper } from '../order/contacts/subComponents/EditContactFormStatusWrapper';
import { IClientUserData } from '../../types/clients';

interface IEditClientContactProps {
  onSubmit: (value: any) => void;
  initialData: IClientUserData;
  onCancel: () => void;
  editFetchError?: Error;
  editFetchStatus: IFetchStatus;
}

export const EditClientContact: React.FC<IEditClientContactProps> = ({
  onSubmit,
  onCancel,
  editFetchError,
  editFetchStatus,
  initialData,
}) => {
  return (
    <Formik
      initialValues={initialData}
      validateOnMount={true}
      validationSchema={clientContactFormValidation}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      onReset={onCancel}
    >
      {({ isValid, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <SideSheet
            title={'Edit Contact'}
            onClose={onCancel}
            footer={
              <Grid columnCount={2}>
                <Button intent={'secondary'} type={'reset'}>
                  Cancel
                </Button>
                <Button intent={'primary'} type={'submit'} disabled={!isValid || !dirty || editFetchStatus.fetching}>
                  Save and Edit
                </Button>
              </Grid>
            }
          >
            <Grid>
              <>
                <EditContactFormStatusWrapper
                  fetching={editFetchStatus.fetching}
                  fetchError={editFetchError}
                  updateFetchedSuccess={editFetchStatus.success}
                  updateSuccessMessage={`Contact Updated!`}
                />
                <ClientContactForm disableNotEditableFields={true} />
              </>
            </Grid>
          </SideSheet>
        </Form>
      )}
    </Formik>
  );
};
